/**
 * @generated SignedSource<<a607e96fd72584b715cbb60a3bf40204>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodosQuery$variables = {
  workspaceId: string;
};
export type WorkspaceTodosQuery$data = {
  readonly workspace: {
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodosList_workspace">;
  };
};
export type WorkspaceTodosQuery = {
  response: WorkspaceTodosQuery$data;
  variables: WorkspaceTodosQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isDate"
  }
],
v5 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodosQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceTodosList_workspace"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodosQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "activeTodos",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "createdAtDate",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledPublishAt",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "publishedAtDate",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "expireAtDate",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrgTopic",
                "kind": "LinkedField",
                "name": "topic",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "kind": "ScalarField",
                "name": "todoCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "kind": "ScalarField",
                "name": "todosCompletedCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priorityOrder",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "kind": "ScalarField",
                "name": "workspaceOwnerName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priority",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "descriptionImages",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbhash",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageSize",
                    "kind": "LinkedField",
                    "name": "sizes",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlExpiresAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "descriptionFiles",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrg",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceProduct",
                "kind": "LinkedField",
                "name": "linkedProducts",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a0c159311555d70dad716286f5a05899",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodosQuery",
    "operationKind": "query",
    "text": "query WorkspaceTodosQuery(\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    ...WorkspaceTodosList_workspace\n    id\n  }\n}\n\nfragment FileIconBox_file on File {\n  type\n  isOrg\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemDescriptionContentFiles_files on File {\n  id\n  ...FileIconBox_file\n}\n\nfragment ListItemDescriptionContentProducts_products on WorkspaceProduct {\n  id\n  ...WorkspaceTodoListItemProducts_WorkspaceProduct\n}\n\nfragment ListItemDescriptionContent_images on Image {\n  id\n  ...Image_image\n}\n\nfragment WorkspaceTodoListItemDescription_todo on TodoWorkspace {\n  title\n  descriptionImages {\n    ...ListItemDescriptionContent_images\n    id\n  }\n  descriptionFiles {\n    ...ListItemDescriptionContentFiles_files\n    id\n  }\n  linkedProducts {\n    ...ListItemDescriptionContentProducts_products\n    id\n  }\n}\n\nfragment WorkspaceTodoListItemProducts_WorkspaceProduct on WorkspaceProduct {\n  name\n}\n\nfragment WorkspaceTodoListItemStatus_todo on TodoWorkspace {\n  status\n  todoCount(workspaceId: $workspaceId)\n  todosCompletedCount(workspaceId: $workspaceId)\n}\n\nfragment WorkspaceTodoListItem_todo on TodoWorkspace {\n  id\n  expireAtDate {\n    ...FormattedDate\n  }\n  scheduledPublishAt {\n    ...FormattedDate\n  }\n  publishedAtDate {\n    ...FormattedDate\n  }\n  status\n  topic {\n    id\n    name\n  }\n  workspaceOwnerName(workspaceId: $workspaceId)\n  priority\n  ...WorkspaceTodoListItemStatus_todo\n  ...WorkspaceTodoListItemDescription_todo\n}\n\nfragment WorkspaceTodosList_workspace on Workspace {\n  id\n  topics {\n    __typename\n    id\n  }\n  activeTodos {\n    id\n    title\n    body\n    createdAtDate {\n      isoString\n    }\n    scheduledPublishAt {\n      isoString\n    }\n    publishedAtDate {\n      isoString\n    }\n    expireAtDate {\n      isoString\n    }\n    topic {\n      id\n      name\n    }\n    status\n    todoCount(workspaceId: $workspaceId)\n    todosCompletedCount(workspaceId: $workspaceId)\n    priorityOrder\n    ...WorkspaceTodoListItem_todo\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "70e0bd5221d6b7ae83d3974b845dc2d4";

export default node;
